import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { get } from '../../utils/makeRequest';

// Async thunks
export const getLatestApiLogs = createAsyncThunk(
  'apiLogs/getLatest',
  async (_, { rejectWithValue }) => {
    try {
      const response = await get('/logs/latest'); // Remove /api prefix
      return response;
    } catch (error) {
      return rejectWithValue(error.response?.data?.error || error.message || 'Failed to fetch API logs');
    }
  }
);

export const getApiUsageAnalytics = createAsyncThunk(
  'apiLogs/getAnalytics',
  async (_, { rejectWithValue }) => {
    try {
      const response = await get('/logs/analytics'); // Remove /api prefix
      return response;
    } catch (error) {
      return rejectWithValue(error.response?.data?.error || error.message || 'Failed to fetch API analytics');
    }
  }
);

const initialState = {
  logs: [],
  analytics: [],
  loading: false,
  error: null,
  lastUpdated: null
};

const apiLogsSlice = createSlice({
  name: 'apiLogs',
  initialState,
  reducers: {
    clearApiLogs: (state) => {
      state.logs = [];
      state.analytics = [];
      state.error = null;
    },
    clearError: (state) => {
      state.error = null;
    }
  },
  extraReducers: (builder) => {
    builder
      // Get latest API logs
      .addCase(getLatestApiLogs.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getLatestApiLogs.fulfilled, (state, action) => {
        state.loading = false;
        state.logs = action.payload.data?.logs || [];
        state.lastUpdated = new Date().toISOString();
      })
      .addCase(getLatestApiLogs.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      // Get API usage analytics
      .addCase(getApiUsageAnalytics.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getApiUsageAnalytics.fulfilled, (state, action) => {
        state.loading = false;
        state.analytics = action.payload.data?.analytics || [];
        state.lastUpdated = new Date().toISOString();
      })
      .addCase(getApiUsageAnalytics.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  }
});

export const { clearApiLogs, clearError } = apiLogsSlice.actions;

// Selectors
export const selectApiLogs = (state) => state.apiLogs.logs;
export const selectApiAnalytics = (state) => state.apiLogs.analytics;
export const selectApiLogsLoading = (state) => state.apiLogs.loading;
export const selectApiLogsError = (state) => state.apiLogs.error;

export default apiLogsSlice.reducer;